<template>
  <div class="min-h-screen bg-gray-50">
    <PaymentLanding />
  </div>
</template>

<script setup lang="ts">
import PaymentLanding from './components/PaymentLanding.vue'
</script>